export default {"src":"/polygon/_next/static/media/lock.146be3a8.svg","height":80,"width":81};